import {mapToTypeFromString} from '../../../common/common';
export enum MemberProgramType {
  REWARDS_CLUB = 'PC',
  BUSINESS_REWARDS = 'BR',
  AMBASSADOR = 'AMB',
  KARMA = 'KAR'
}
export namespace MemberProgramType {
  export const fromString = (input: string): MemberProgramType => {
    return mapToTypeFromString<MemberProgramType>(MemberProgramType, input);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/member-program-type.model.ts